import {useQuery, gql} from "@apollo/client";
var  NEWS_LIST = gql`
query NewsList {    
  news(where: {localization: {culture_starts_with: "fa"}}) {
    displayText
    id
    newsBody {
      html
    }
    newsOverview {
      html
    }
    bag {
      contentItems {
        ... on NewsImage {
          createdUtc
          displayText
          imageTitle
          image {
            urls(first: 1)
          }
        }
      }
    }
    newsDate
    newsGroup {
      contentItems {
        ... on NewsGroup {
          displayText
        }
      }
    }
  }
  }
`;

export const useNewsList = () => {
  const {error, loading, data} = useQuery(NEWS_LIST);
  
  return {
    error, data, loading
  };
  } 